/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkin_Qr_HintInputs */



/**
* | output |
* | --- |
* | "Point your camera at the organizer's QR code" |
*
* @param {Checkin_Qr_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const checkin_qr_hint = /** @type {((inputs?: Checkin_Qr_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkin_Qr_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dirigez votre caméra vers le QR code de l'organisateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Apunta tu cámara al código QR del organizador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Aponte sua câmera para o código QR do organizador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punta la fotocamera verso il codice QR dell'organizzatore")
	return /** @type {LocalizedString} */ ("Point your camera at the organizer's QR code")
});